<div class="p-5">
    <div class="mb-3 text-center">
        <div class="font-bold text-lg">Thank you for your feedback!</div>
        <div>Please enter your email address to submit</div>
    </div>
    <div>
      <input class="w-[100%]" id="userInput" type="email" placeholder="Email Address" [(ngModel)]="userInput" pInputText />
    </div>
    <div class="mt-3 flex justify-center gap-2">
        <p-button [outlined]="true" label="Cancel" (click)="cancel()" />
        <p-button [disabled]="!isValidEmail()" label="Submit" (click)="submit()" />
    </div>
</div>